export default __webpack_public_path__ + "static/media/portada_FrankAgraz.8fdc7f1c.jpg";